import React from 'react';
import { NavLink, useParams, useLocation } from 'react-router-dom';
import { Home, BarChart2, ClipboardList, Wrench, ShoppingBag, LogOut, Settings } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { useAlert } from '../context/AlertContext';
import './MobileNav.css';

const MobileNav = () => {
    const { id } = useParams();
    const location = useLocation();
    const { user, logout, selectedStoreId, stores } = useStore();
    const { showAlert } = useAlert();
    
    // URL에서 date 파라미터 추출
    const queryParams = new URLSearchParams(location.search);
    const currentDateParam = queryParams.get('date');
    const dateQuery = currentDateParam ? `?date=${currentDateParam}` : '';

    // 관리자1, 2, 3인 경우 볼 수 있는 매장 필터링
    const allowedStores = React.useMemo(() => {
        if (!stores) return [];
        const restrictedAdmins = ['admin1', 'admin2', 'admin3'];
        if (user?.role === 'admin' && restrictedAdmins.includes(user?.id?.toLowerCase())) {
            return stores.filter(s => s.operatingType === 'direct');
        }
        return stores;
    }, [stores, user]);

    // 현재 선택된 매장 ID
    // 관리자일 경우 대시보드에서 선택한 selectedStoreId를 우선 참조하고, 
    // 그 정보가 'all'이거나 비어있으면 URL의 id 또는 기본적으로 가용한 첫 번째 매장 사용합니다.
    const effectiveAdminStoreId = (selectedStoreId && selectedStoreId !== 'all') ? selectedStoreId : (id || (allowedStores[0]?.id || '1'));
    const currentStoreId = user?.role === 'manager' ? user.storeId : effectiveAdminStoreId;

    const handleLogout = () => {
        showAlert('로그아웃 하시겠습니까?', {
            type: 'confirm',
            onConfirm: async () => {
                await logout();
                window.location.replace('/login');
            }
        });
    };

    return (
        <nav className="mobile-nav">
            <NavLink to="/dashboard" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                <Home size={20} />
                <span>홈</span>
            </NavLink>
            <NavLink to={`/store/${currentStoreId}/sales${dateQuery}`} className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                <BarChart2 size={20} />
                <span>매출</span>
            </NavLink>
            <NavLink to={`/store/${currentStoreId}/inventory${dateQuery}`} className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                <ClipboardList size={20} />
                <span>재고</span>
            </NavLink>
            <NavLink to={`/store/${currentStoreId}/facility${dateQuery}`} className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                <Wrench size={20} />
                <span>시설</span>
            </NavLink>
            <NavLink to={`/store/${currentStoreId}/order${dateQuery}`} className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                <ShoppingBag size={20} />
                <span>발주</span>
            </NavLink>
            {/* 매니저 / 관리자(admin) 전용: 매장 설정 탭 */}
            {(user?.role === 'manager' || user?.role === 'admin') && (
                <NavLink to={`/store/${currentStoreId}/mobile-settings`} className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <Settings size={20} />
                    <span>설정</span>
                </NavLink>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minWidth: '40px', padding: '0 4px' }}>
                 <span style={{ fontSize: '0.6rem', color: '#64748b', fontWeight: 'bold' }}>v3.5.7.2</span>
            </div>
            <button onClick={handleLogout} className="mobile-nav-item logout">
                <LogOut size={20} />
                <span>로그아웃</span>
            </button>
        </nav>
    );
};

export default MobileNav;
